import "../../styles/components/shutdown/ShutdownNotice.scss";
import { Link } from "react-router-dom";

export default function ShutdownNotice(props) {
  return (
    <div className="ShutdownNotice">
      <p>
        Thank you for visiting. EPYC Explorer is now closed.
      </p>
      <p>
        If you have any questions regarding your experience, please feel free to <a href="mailto:gcp@amd.com">contact us</a>.
      </p>
      <div className="terms-of-service">
        <span>
          <Link to={{ pathname: "/terms-of-service" }}>Terms of Service</Link>{" "}
          &nbsp;|&nbsp;
          <a
            href="https://www.amd.com/en/legal/privacy.html"
            target="_blank"
            rel="noreferrer"
          >
            Privacy Policy
          </a>
          .
        </span>
      </div>
    </div>
  );
}
